import OrganisationChart from './container/index';

export default OrganisationChart;


// WEBPACK FOOTER //
// ./src/views/Setup/OrganisationChart/index.js